// Translations
import landing from '../views/landing/translations/en'

// Translation: Terms of service (English)
export default Object.freeze({
	name: 'Terms of service',
	views: { landing }
})
